import Chip from '../ui/Chip.jsx'
import { timeAgo } from '../../lib/timeAgo.js'

const TAG_TONES = {
  bilan_personnel: 'neutral',
  bilan_patrimonial: 'actif',
  situation_fiscale: 'fiscal',
  objectifs: 'objectif',
  strategie_investissement: 'objectif',
  strategie_immobiliere: 'actif',
  prevoyance_protection: 'neutral',
  retraite: 'objectif',
  transmission_succession: 'neutral',
  recommandations_plan_action: 'fiscal',
}
const TAG_LABEL = {
  bilan_personnel: 'Personnel',
  bilan_patrimonial: 'Patrimoine',
  situation_fiscale: 'Fiscal',
  objectifs: 'Objectif',
  strategie_investissement: 'Stratégie',
  strategie_immobiliere: 'Immobilier',
  prevoyance_protection: 'Prévoyance',
  retraite: 'Retraite',
  transmission_succession: 'Transmission',
  recommandations_plan_action: 'Recommandation',
}

export default function FactCard({ fact, now = Date.now() }) {
  const essential = !!fact.is_essentiel
  const cardCls = essential ? 'border-terra-500 bg-white' : 'border-line bg-white'
  const textCls = essential ? 'font-semibold' : ''
  return (
    <div className={`mb-1.5 animate-fade-up rounded-xl border px-4 py-3 ${cardCls}`}>
      <div className="mb-1 flex items-center gap-1.5">
        {essential
          ? <>
              <span className="text-[11px] text-terra-500">★</span>
              <Chip tone="essentiel">ESSENTIEL</Chip>
            </>
          : <Chip tone={TAG_TONES[fact.section] || 'neutral'}>{TAG_LABEL[fact.section] || 'Fait'}</Chip>}
        <span className="ml-auto text-[10.5px] tabular-nums text-muted/80">{timeAgo(fact.last_updated, now)}</span>
      </div>
      <div className={`text-[13.5px] leading-snug ${textCls}`}>{fact.value}</div>
    </div>
  )
}
